var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"grundgedanke-section"},[_c('div',{staticClass:"content-container"},[_c('div',[_vm._t("title")],2),_vm._v(" "),_c('div',[_vm._t("text")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }